import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
	CardDescription,
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { FcGoogle } from 'react-icons/fc';
import { Loader2 } from 'lucide-react';
import { useGoogleLogin } from '@/hooks/useGoogleLogin.hooks';
import { ApiTypes } from '@/types/server/api.types';

export const LoginPage = ({
	setIsUserLoggedIn,
	setUserDetails,
}: {
	setIsUserLoggedIn: (isUserLoggedIn: boolean) => void;
	setUserDetails: (
		userDetails: ApiTypes.TGetCandidateDetailsResponse['data']
	) => void;
}) => {
	const { isLoading, initiateGoogleLogin, isGoogleAvailable } = useGoogleLogin({
		setIsUserLoggedIn,
		setUserDetails,
	});

	return (
		<div className="flex items-center justify-center mt-[25vh] ml-4 mr-4">
			<Card className="w-full max-w-md shadow-lg rounded-md">
				<CardHeader className="text-center">
					<CardTitle className="text-2xl font-semibold">Login</CardTitle>
					<CardDescription>Sign in to your account to continue</CardDescription>
				</CardHeader>

				<CardContent className="space-y-6">
					<Button
						disabled={isLoading || !isGoogleAvailable}
						variant="outline"
						className="w-full flex items-center justify-center gap-2 cursor-pointer"
						onClick={initiateGoogleLogin}
					>
						{isLoading ? (
							<Loader2 className="h-4 w-4 animate-spin" />
						) : (
							<FcGoogle size={20} />
						)}
						{isLoading ? 'Logging in...' : 'Continue with Google'}
					</Button>

					<hr className="border-t border-gray-200" />

					<p className="text-xs text-muted-foreground text-center">
						Please login with the email you want to receive critical job-related
						notifications on.
					</p>
				</CardContent>
			</Card>
		</div>
	);
};
